import { action, decorate, observable } from "mobx";
import get from "lodash/get";
import moment from "moment";
import {
    checkComissionBalance,
    comissionRequestOTP
} from "../services/ComissionService";

class ComissionStore {
    comissionBalance = {};
    convertedComission = {};
    isLoading = false;
    formData = {};

    checkComissionBalance = async () => {
        this.isLoading = true;
        const { data, error } = await checkComissionBalance();
    
        if (data) {
            this.comissionBalance = data;
            this.isLoading = false;
            return { data };
        } else {
            this.isLoading = false;
            return { error };
        }
    }

    comissionRequestOTP = async () => {
        const postData = {
            amount: (parseInt(this.formData['amount'])/100) * parseInt(get(this.comissionBalance, "available")),
            commissionCurrency: "IDR",
            targetCurrency: "BTC"
        }
        const { data, error } = await comissionRequestOTP(postData);
    
        if (data) {
            this.isLoading = false;
            return { data };
        } else {
            this.isLoading = false;
            return { error };
        }
    }
    convertComission = async () => {
        const postData = {
            otp: this.formData['otp_code'],
            amount: (parseInt(this.formData['amount'])/100) * parseInt(get(this.comissionBalance, "available")),
            commissionCurrency: "IDR",
            targetCurrency: "BTC"
        }
        const { data, error } = await comissionRequestOTP(postData);
    
        if (data) {
            this.convertedComission = data;
            this.isLoading = false;
            return { data };
        } else {
            this.isLoading = false;
            return { error };
        }
    }

    setFormData = (data) => {
        this.formData = {...this.formData, ...data};
    }
    resetFormData = () => {
        this.formData = {};
    }
    resetConvertedComission = () => {
        this.convertedComission = {};
    }
    prepareDefaultValue = () => {
        this.formData = {};
        this.comissionBalance = {};
        this.convertedComission = {};
    }
}

decorate(ComissionStore, {
    isLoading: observable,
    comissionBalance: observable,
    formData: observable,
    convertedComission: observable,

    checkComissionBalance: action,
    convertComission: action,
    comissionRequestOTP: action,
    prepareDefaultValue: action,
    setFormData: action,
    resetFormData: action,
    resetConvertedComission: action
});
export default new ComissionStore();
